import {
  DeleteWorkAreaMapDocument,
  DeleteWorkAreaMapMutation,
  DeleteWorkAreaMapMutationVariables,
  GetWorkAreaMapsDocument,
  GetWorkAreasDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useDeleteWorkAreaMap = () => {
  const [executeMutation] = useMutation(DeleteWorkAreaMapDocument, {
    extractorFn: (data: DeleteWorkAreaMapMutation) =>
      data.spaceControlMutations.deleteSpacecontrolWorkAreaMap,
  })

  const deleteWorkAreaMap = async (variables: DeleteWorkAreaMapMutationVariables) => {
    return executeMutation({
      variables,
      refetchQueries: [GetWorkAreaMapsDocument, GetWorkAreasDocument],
    })
  }

  return {
    deleteWorkAreaMap,
  }
}
